import {
    ComponentManager,
    ControlFactory,
    DetailViewContext,
    InlineEditContext,
    InlineEditingGridViewModel, RADApplication, StorageHelper,
    UIListener
} from 'radpresentation.htmlclient.defaultviewextensions';
import UIListenerUtility from '@/Utils/UIListenerUtility';

class BestellungUIListener extends UIListener
{
    public override onAssociationUpdated(context: DetailViewContext, relation: string) {
        if (relation === 'BestellItem')
        {
            context.refreshProperties(['Gesamtpreis']);
        }
    };

    public override onDetailViewReady(context: DetailViewContext)
    {
        this.registerInlineGridListeners(context);

        this.makeReadonly(context);
    }

    public override onAfterCallOperation(context: DetailViewContext, operation: string, args: any)
    {
        if (operation === 'Send')
        {
            if (context.validateStatus(args, false ))
            {
                context.apply().then(result =>
                    {
                        if (result)
                        {
                            this.makeReadonly(context);
                        }
                        return result;
                    }
                );
            }
        }
    }

    private registerInlineGridListeners(context: DetailViewContext)
    {
        const grid = this.getBestellItemGrid(context);
        if (!grid)
        {
            console.error('BestellItem-Grid nicht gefunden');
            return;
        }

        // Live-Berechnung bei Eingabe der Anzahl (bzw. wenn der ProduktPreis ankommt).
        grid.onPropertyValueChanged((ieCtx: InlineEditContext, property: string) =>
        {
            if (property === 'Anzahl' || property === 'ProduktPreis')
            {
                this.updateLive(context, grid, ieCtx);
            }
        });

        // Nach dem Speichern einer Zeile: Grid lädt sich selbst neu (Positionswert),
        // Gesamtpreis autoritativ vom Server holen.
        // Das Control ruft viewModel.onSave(row) live auf, daher greift das Überschreiben.
        const originalOnSave = grid.onSave.bind(grid);
        grid.onSave = (row: any) =>
        {
            const promise = originalOnSave(row);
            promise.then((success: boolean) =>
            {
                if (success)
                {
                    context.refreshProperties(['Gesamtpreis']);
                }
            });
            return promise;
        };
    }

    /**
     * Aktualisiert den Positionswert der bearbeiteten Zeile und berechnet den
     * Gesamtpreis frisch als Summe aller Zeilen (ohne Server-Roundtrip).
     */
    private updateLive(context: DetailViewContext, grid: InlineEditingGridViewModel, ieCtx: InlineEditContext)
    {
        const genericObject = ieCtx.genericObject;
        const editedPdoId = genericObject.pdoId;

        const positionswert$ = genericObject.getObservable('Positionswert');
        const gesamtpreis$ = context.genericObject.getObservable('Gesamtpreis');
        const anzahl = genericObject.getValue('Anzahl');
        const preis = genericObject.getValue('ProduktPreis');

        const editedPositionswert = this.toNumber(anzahl) * this.toNumber(preis);
        positionswert$(editedPositionswert);

        let gesamt = 0;
        for (const row of grid.dataSource())
        {
            const positionswert = this.toNumber(row.values?.['Positionswert']);
            gesamt += row.pdoId === editedPdoId
                      ? editedPositionswert
                      : positionswert;
        }

        const x = gesamt.toFixed(2);
        const y = x.toString();
        gesamtpreis$(y);

    }

    private toNumber(value: any): number
    {
        const n = Number(value);
        return isNaN(n) ? 0 : n;
    }

    private getBestellItemGrid(context: DetailViewContext): InlineEditingGridViewModel
    {
        const factory = context.getUIFactory<ControlFactory>('BestellItem');
        return factory?.viewModel as InlineEditingGridViewModel;
    }

    private makeReadonly(context) {
        const value = context.genericObject.getValue('SendetAt');
        if (value)
        {
            UIListenerUtility.makeEverythingReadonly(context);
            context.toolBar.getElementByMethodName('Send').isEnabled(false);
        }
    }
}

ComponentManager.setUIListener('BestellungUIListener', BestellungUIListener, 'ONVHTMLViewExtension');
